import {ReactNode} from "react";
import classes from "./Form.module.css";

type FormProps = {
    /**
     * Children to display is required.
     * @author Kacper Faber
     * @since 0.1.8
     */
    children: ReactNode | ReactNode[];

    /**
     * Icon to be displayed in header.
     * @author Kacper Faber
     * @since 0.1.8
     */
    icon?: ReactNode;

    /**
     * Label to be displayed in header.
     * @author Kacper Faber
     * @since 0.1.8
     */
    label?: string;
}

/**
 * Form
 * @author Kacper Faber
 * @since 0.1.8
 * @param props
 * @constructor
 */
function Form(props: FormProps) {
    return (
        <div className={classes.root}>
            <div className={classes.header} style={{ color: '#616568' }}>
                { props.icon }

                <h4 style={{ color: "#616568", margin: 0, padding: 0 }}>{props.label}</h4>
            </div>

            <div className={classes.content}>
                { props.children }
            </div>
        </div>
    );
}

export default Form;